import React from 'react';
import Header from './Header/Header';
import Switcher from './Switcher';
import Footer from './Footer/Footer';
import '../index.scss';

const App = () => (
	<div id="app">
		<Header />
		<Switcher />
		<Footer />
	</div>
);

export default App;
